import "../styles/main.scss";
import "./bootstrap.config";

import axios from "axios";
import Vue from "vue";
import store from "./store/index";
import i18n from "./i18n/index";

import Raven from "raven-js";
import RavenVue from "raven-js/plugins/vue";

import ArticleList from "./components/article-list.vue";

let dsn = document.documentElement.getAttribute("data-sentry-dsn");
let git_hash = document.documentElement.getAttribute("data-git-hash");
Raven.config(dsn, { release: git_hash }).addPlugin(RavenVue, Vue).install();
Raven.context(run);

function run() {
    axios.defaults.xsrfCookieName = "csrftoken";
    axios.defaults.xsrfHeaderName = "X-CSRFToken";

    window.addEventListener("load", function () {
        i18n.locale = LANGUAGE;
        if (document.getElementById("app") !== null) {
            new Vue({
                el: "#app",
                store: store,
                i18n: i18n,
                components: {
                    "article-list": ArticleList,
                },
            });
        }
    });
}
